module.exports = (promoCode) => `
  mutation {
    applyPromotionToCurrentOrder(promoCode: "${promoCode}") {
      messageType,
      messageText,
      order {
        number
        state
        currency
        displayTotal
        isRegistrationValid
        isShippingValid
        isPaymentValid
        isTaxIncluded
        adyenTotalAmount
        items {
          sku
          variantId
          color
          groupName
          imageUrl
          price
          productPath
          productType
          quantity
          size
          stock
        }
        promotionAdjustment {
          code
          amount
          currency
        }
        taxAdjustments {
          label
          amount
          type
        }
      }
    }
  }
`
